import { createFileRoute, redirect } from '@tanstack/react-router'
import { VISIO_REVIEWS_PAGE_READ, VISIO_REVIEWS_TABS } from '~/components/routes/visioReviews/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

/**
 * L'écran n'a pas de contenu propre : chaque onglet est une route. On redirige vers le premier
 * accessible — `withRoutePermissions` refuse d'abord l'accès si aucun ne l'est.
 */
export const Route = createFileRoute('/_authenticated/visio-reviews/')({
  staticData: {
    permission: VISIO_REVIEWS_PAGE_READ,
  },
  beforeLoad: ({ context }) => {
    const first = VISIO_REVIEWS_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )
    throw redirect({ to: first?.to ?? VISIO_REVIEWS_TABS[0].to })
  },
})
withRoutePermissions(Route)
